import React from "react";
import { MessageCircle } from "lucide-react";

export function ChatButton({ order, onOpen, admin = false, highlight = false }) {
  const unread = Number(order?.unread_messages || 0);
  const testId = admin ? `admin-order-chat-btn-${order.id}` : `client-order-chat-btn-${order.id}`;
  return (
    <button
      onClick={onOpen}
      data-testid={testId}
      aria-label="Abrir chat de soporte del pedido"
      className={`relative px-3 sm:px-4 py-2 rounded-xl text-xs font-bold flex items-center gap-2 border transition-colors ${
        admin
          ? "bg-cyan-600/15 hover:bg-cyan-600/30 text-cyan-200 border-cyan-500/40"
          : "bg-purple-600/15 hover:bg-purple-600/30 text-purple-200 border-purple-500/40"
      } ${highlight && !admin ? "border-purple-400/80 shadow-[0_0_16px_rgba(168,85,247,0.35)] animate-pulse-slow" : ""}`}
    >
      <MessageCircle className="w-4 h-4" strokeWidth={2.2} />
      <span>Chat de soporte</span>
      {unread > 0 && (
        <span
          data-testid={`${admin ? "admin" : "client"}-order-chat-unread-${order.id}`}
          className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 border-2 border-[#0f1015] text-[10px] font-extrabold text-white flex items-center justify-center"
        >
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
}
